// ~/i18n.config.ts
import en_US   from './locales/en_US.json'
import zh_Hans from './locales/zh_Hans.json'
import zh_Hant from './locales/zh_Hant.json'



export default defineI18nConfig(() => {
  return {
    legacy: false,
    locale: 'zh-Hans',
    fallbackLocale: 'zh-Hans',
  
    messages: {
      "en-US": en_US,
      // Alias for Simplified Chinese
      "zh": zh_Hans,
      "zh-Hans": zh_Hans,
      "zh-Hant": zh_Hant
    }
  }
})


